import { useRef } from 'react';
import { FileUpload } from 'primereact/fileupload';
import GroupTile from '../GroupTile/GroupTile';
import useTilePreview from '../../hooks/useTilePreview';

const MAX_TILE_SIZE = 5 * 1024 * 1024;
const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

export default function TileImageField({ file, onFileChange, fallbackUrl, name, onError }) {
  const uploadRef = useRef(null);
  const preview = useTilePreview(file, fallbackUrl);

  function handleSelect(e) {
    const picked = e.files?.[0];
    uploadRef.current?.clear();
    if (!picked) return;
    if (!ACCEPTED_IMAGE_TYPES.includes(picked.type)) {
      onError('Only jpeg, png, webp, or gif images are allowed.');
      return;
    }
    if (picked.size > MAX_TILE_SIZE) {
      onError('Image must be 5 MB or smaller.');
      return;
    }
    onFileChange(picked);
  }

  return (
    <div className="field">
      <label>Tile image</label>
      <div className="mb-3">
        <GroupTile imageUrl={preview} name={name || 'Group name'} />
      </div>
      <FileUpload
        ref={uploadRef}
        mode="basic"
        accept="image/jpeg,image/png,image/webp,image/gif"
        auto={false}
        chooseLabel={file ? file.name : fallbackUrl ? 'Replace image' : 'Choose image'}
        customUpload
        uploadHandler={() => {}}
        onSelect={handleSelect}
        className="mb-3"
      />
      <p className="textMuted mb-3">
        4:3 image (e.g. 1200×900) fits best — it&apos;s center-cropped to the tile. Up to 5 MB,
        optional.
      </p>
    </div>
  );
}
